// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"acc5f4f4","442":"bce5be8c","721":"55803deb"}[chunkId] + ".chunk.js";
};